var AdaptImage = $.extend({/* AdaptImage */}, BaseComponent, {

	componentSelector: '.img-cover',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {
		var img = $(element).children('img');

		var backgroundImgURL = img.attr('src');

		$(element).css(this.addCoverStyles(backgroundImgURL));
	},

	addCoverStyles: function(src) {
		var styles = {
			'background-image' : 'url('+src+')',
			'background-repeat' : 'no-repeat',
			'background-position' : 'center center',
			'background-size' : 'cover',
			'-webkit-background-size' : 'cover',
			'-moz-background-size' : 'cover',
			'-o-background-size' : 'cover'
		}

		return styles;
	}
})